var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08724 15.3346C4.03715 15.3346 0.753906 12.0514 0.753906 8.0013C0.753906 3.95121 4.03715 0.667969 8.08724 0.667969C12.1373 0.667969 15.4206 3.95121 15.4206 8.0013C15.4206 12.0514 12.1373 15.3346 8.08724 15.3346ZM12.7744 11.7457C13.5958 10.7191 14.0869 9.41693 14.0869 8C14.0869 4.68629 11.4006 2 8.08691 2C6.66999 2 5.36778 2.49116 4.34125 3.3125L12.7744 11.7457ZM11.8315 12.6884C10.8051 13.5092 9.50334 14 8.08691 14C4.77321 14 2.08691 11.3137 2.08691 8C2.08691 6.58357 2.57772 5.28178 3.39855 4.25542L11.8315 12.6884Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBlock);
export default __webpack_public_path__ + "static/media/circle-block.b1403565.svg";
export { ForwardRef as ReactComponent };